import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Shop, StoreHour } from '../../../models/vendor.model';

@Component({
  selector: 'app-shop-quick-view',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './shop-quick-view.component.html',
  styleUrls: ['./shop-quick-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShopQuickViewComponent {
  @Input({ required: true }) shop!: Shop;

  constructor(public activeModal: NgbActiveModal) {}

  get bannerImage(): string {
    return this.shop.cover_image || this.shop.shop_image || 'assets/images/no-image.jpg';
  }

  get logoImage(): string {
    return this.shop.shop_image || 'assets/images/no-image.jpg';
  }

  get isOpen(): boolean {
    return !!this.shop.is_accepting_orders;
  }

  get todayHours(): StoreHour | null {
    if (!this.shop.store_hours?.length) return null;
    const today = new Date().getDay();
    return this.shop.store_hours.find(h => h.day_of_week === today) ?? null;
  }
}
